import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { restURL } from '../Models/restURL';
import * as CryptoJS from 'crypto-js';
import { motorProposalService } from './motorProposalService';
import { environment } from '../environments/environment';
import { Injector } from '@angular/core';

@Injectable()
export class userService {

    private isValid: boolean;
    public httpOptions: Object;
    private _router: Router;
    // public  httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json','apiToken':this.getToken()})}; 
    constructor(private EncriptService: motorProposalService,private injector: Injector, private Url: restURL) {
        this.isValid = false;
    }
    private get router(): Router {
        if (!this._router) {
          this._router = this.injector.get(Router); // Lazy load Router
        }
        return this._router;
      }
    setToken(token: string) {
        sessionStorage.setItem("token", token);
    }
    isAuthenticatedUser(): boolean {
        if (sessionStorage.getItem("token") != null) {
            this.isValid = true;
        }
        return this.isValid;
    }
    getToken(): string {
        let token: string = "";
        if (sessionStorage.getItem("token") != null) {
            token = sessionStorage.getItem("token");
        }
        return token;
    }

    getHttpOptions(): Object {
        var header: HttpHeaders = new HttpHeaders();

        var param = environment;     
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }

        var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
        var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));

        header = header.append('Content-Type', 'application/json');
        header = header.append('Accept-Encoding', 'gzip');
        header = header.append('apiToken', this.getToken());

        header = header.append("Authorization", "Basic " + btoa(UserName + ':' + Password));
        this.httpOptions = { headers: header };
        return this.httpOptions;
    }

    checkTokenStatus(error) {
        if (error.status == "401") {
            alert("Unauthorized Acess ");
            sessionStorage.clear();
            this.router.navigate(["/BeforeLogin/Login"]);
        }
    }

    EncriptString(RegNo): Object {
        var param = environment;                
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }

        var passKey = param.St.StatusDesc;
        var key = CryptoJS.enc.Utf8.parse(passKey);
        var iv = CryptoJS.enc.Utf8.parse(passKey);
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(RegNo), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        return encrypted;
    }

    getHttpOptions3(): Object {
        var header: HttpHeaders = new HttpHeaders();

        var param = environment;          
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }

        var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
        var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));

        header.delete('Content-Type');
        header.set('enctype', "multipart/form-data");
        header = header.append('Accept-Encoding', 'gzip');
        header = header.append('apiToken', this.getToken());
        header = header.append("Authorization", "Basic " + btoa(UserName + ':' + Password));
        this.httpOptions = { headers: header };
        return this.httpOptions;
    }


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/userService.ts